export default function NotebookIcon({ className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 640 640"
      className={className}
    >
      <path d="M240 112L240 528L192 528C183.2 528 176 520.8 176 512L176 128C176 119.2 183.2 112 192 112L240 112zM288 112L480 112C488.8 112 496 119.2 496 128L496 512C496 520.8 488.8 528 480 528L288 528L288 112zM192 64C156.7 64 128 92.7 128 128L128 168L88 168C74.7 168 64 178.7 64 192C64 205.3 74.7 216 88 216L128 216L128 296L88 296C74.7 296 64 306.7 64 320C64 333.3 74.7 344 88 344L128 344L128 424L88 424C74.7 424 64 434.7 64 448C64 461.3 74.7 472 88 472L128 472L128 512C128 547.3 156.7 576 192 576L480 576C515.3 576 544 547.3 544 512L544 128C544 92.7 515.3 64 480 64L192 64z" />
    </svg>
  );
}
